import React, { useEffect, useState } from "react";
import { Form, Modal, Row, Col, Image } from "react-bootstrap";
import SearchSelect from "../common/SearchSelect";
import Swal from "sweetalert2";
import xclose from "../../assets/x-close.svg"
import withReactContent from "sweetalert2-react-content";
import Alert from "../common/Alert";
import constants from "../../helpers/constants";
import InputBox from "../common/InputBox";
import FormButtons from "../common/FormButtons";
import { addFinanceCode, editFinanceCode } from "../../services/finance-service";
import Loader from "../common/loader";
import { validateAlphaNumeric } from "../../helpers/validations";

const FinanceForm = (props) => {
    const MySwal = withReactContent(Swal);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({});
    const [errorMessage, setErrorMessage] = useState();
    const [submit, setSubmit] = useState(false);
    const [fieldCount, setFieldCount] = useState([]);
    const [isFormChanged, setIsFormChanged] = useState(false);
    const [mandatoryFields, setMandatoryFields] = useState([]);
    const [mandatoryFieldsBKP, setMandatoryFieldsBKP] = useState([]);

    let action = props.action;

    useEffect(() => {
        setError();
        setErrorMessage()
    }, [props.action])

    useEffect(() => {
        if (mandatoryFields.length > 0) {
            setMandatoryFieldsBKP([...mandatoryFields]);
        }
    }, [mandatoryFields])

    const validateDetails = () => {
        let tempError = false;
        for (let errorObj in error) {
            if (error[errorObj]) {
                tempError = true;
                break;
            }
        }
        if (tempError) {
            setErrorMessage("Please check above errors")
        } else {
            setErrorMessage("")
        }
        return tempError;
    }

    const submitForm = (e) => {
        if (isFormChanged) {
            e.preventDefault();
            setSubmit(submit ? false : true);
        } else {
            setErrorMessage("No changes in finance code")
        }
    }

    useEffect(() => {
        let fieldValidation = 7;
        if (fieldCount.length >= fieldValidation) {
            setSubmit(submit ? false : true);
            handleSubmit();
            setFieldCount([]);
        }
    }, [fieldCount, action]);

    const handleSubmit = async () => {
        const fieldsToValidate = ['vendorCode', 'gadCustomerCode', 'lob', 'financeCode', 'retailerGstin', 'retailerName', 'dstAssociation'];
        for (let field of fieldsToValidate) {
            if (financeObj[field] && /[!@#$%^&*(),.?":{}|<>]/g.test(financeObj[field])) {
                setErrorMessage("Fields should not contain any special character")
                return
            }
        }

        if (!validateDetails()) {
            let confirmationMessage = action === "Add"
                ? "Are you sure do you want to Add New Finance Code?"
                : "Are you sure do you want to Update Selected Finance Code?";
            let title = action === "Add" ? "Add New Finance Code" : "Edit Finance Code";

            MySwal.fire({
                title: title,
                html: confirmationMessage,
                ...constants.CONFIRMATION_BOX_CONFIG
            }).then(async (selection) => {
                if (selection.isConfirmed) {
                    setLoading(true)
                    let result;

                    if (action === "Add") {
                        if (props.financedata.filter((item) =>
                            item.vendorCode?.toLowerCase() === financeObj.vendorCode?.toLowerCase() &&
                            item.gadCustomerCode?.toLowerCase() === financeObj.gadCustomerCode?.toLowerCase() &&
                            item.financeCode?.toLowerCase() === financeObj.financeCode?.toLowerCase()
                        ).length > 0) {
                            setErrorMessage("Finance Code already exists.");
                            setLoading(false);
                            return;
                        }

                        const financeData = {
                            ...financeObj,
                            status: "Active",
                            createdOn: new Date(),
                            createdById: sessionStorage.getItem("Email") || sessionStorage.getItem("UserName")
                        };

                        result = addFinanceCode(financeData);
                        result.then((resp) => {
                            Alert("success", "Finance added successfully")
                            props.onHide();
                            props.setReload();
                        }).catch((err) => {
                            setErrorMessage(err);
                            setLoading(false)
                        })
                    }

                    if (action === "Edit") {
                        const editData = {
                            ...financeObj,
                            updatedBy: sessionStorage.getItem("Email") || sessionStorage.getItem("UserName")
                        };

                        result = editFinanceCode(editData);
                        result.then((resp) => {
                            Alert("success", resp.message)
                            props.onHide();
                            props.setReload();
                        }).catch((err) => {
                            setErrorMessage(typeof err === 'string' ? err : err?.response?.data?.message || err?.message || 'An error occurred');
                            setLoading(false)
                        })
                    }
                }
            });
        }
    }

    const [financeObj, setFinanceObj] = useState(
        action === "Edit"
            ? { ...props.rowdata }
            : {
                vendorCode: "",
                gadCustomerCode: "",
                lob: "",
                financeCode: "",
                retailerGstin: "",
                retailerName: "",
                dstAssociation: "",
                status: "Active"
            }
    );

    const handleReset = () => {
        if (action === "Add") {
            setFinanceObj({
                vendorCode: "",
                gadCustomerCode: "",
                lob: "",
                financeCode: "",
                retailerGstin: "",
                retailerName: "",
                dstAssociation: "",
                status: "Active"
            });
            setMandatoryFields([...mandatoryFieldsBKP]);
        } else if (action === "Edit") {
            setFinanceObj({ ...props.rowdata });
        }
        setIsFormChanged(false);
        setError({});
        setErrorMessage()
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFinanceObj((prevState) => ({
            ...prevState,
            [name]: value,
        }));
        setIsFormChanged(true);
    }

    const commonProps = { setError: setError, error: error, submit: submit, setFieldCount: setFieldCount, fieldCount: fieldCount, onChange: handleChange, required: "true", mandatoryFields: mandatoryFields, setMandatoryFields: setMandatoryFields }

    return (
        <>
            {loading && <Loader />}
            <Modal
                {...props}
                size="lg"
                backdrop="static"
                className="financeModal"
                enforceFocus={false}
            >
                <Modal.Header >
                    <Image src={xclose} onClick={props.onHide}></Image>
                    <Modal.Title className="modal-title">
                        {action} {action === "Edit" ? "" : "New"} Finance Code
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row >
                        <Col lg={6} md={12} className="txt-input">
                            <InputBox type="text" label="Vendor Code" maxLength={50} name="vendorCode" id="vendorCodeID" value={financeObj.vendorCode} customValidation={validateAlphaNumeric} {...commonProps} disabled={action === "Edit"} required />
                        </Col>
                        <Col lg={6} md={12} className="txt-input">
                            <InputBox type="text" label="GAD Customer Code" maxLength={50} name="gadCustomerCode" id="gadCustomerCodeID" value={financeObj.gadCustomerCode} customValidation={validateAlphaNumeric} {...commonProps} disabled={action === "Edit"} required />
                        </Col>
                    </Row>
                    <Row >
                        <Col lg={6} md={12} className="txt-input">
                            <InputBox type="text" label="LOB" maxLength={50} name="lob" id="lobID" value={financeObj.lob} customValidation={validateAlphaNumeric} {...commonProps} required />
                        </Col>
                        <Col lg={6} md={12} className="txt-input">
                            <InputBox type="text" label="Finance Code" maxLength={50} name="financeCode" id="financeCodeID" value={financeObj.financeCode} customValidation={validateAlphaNumeric} {...commonProps} disabled={action === "Edit"} required />
                        </Col>
                    </Row>
                    <Row >
                        <Col lg={6} md={12} className="txt-input">
                            <InputBox type="text" label="Retailer GSTIN" maxLength={50} name="retailerGstin" id="ID" value={financeObj.retailerGstin} customValidation={validateAlphaNumeric} {...commonProps} required />
                        </Col>
                        <Col lg={6} md={12} className="txt-input">
                            <InputBox type="text" label="Retailer Name" maxLength={50} name="retailerName" id="retailerNameID" value={financeObj.retailerName} customValidation={validateAlphaNumeric} {...commonProps} required />
                        </Col>
                    </Row>
                    <Row >
                        <Col lg={6} md={12} className="txt-input">
                            <SearchSelect
                                data={props.dstAssociation}
                                name="dstAssociation"
                                value={financeObj.dstAssociation}
                                id="dstAssociationID"
                                label="DST Association"
                                {...commonProps}
                            ></SearchSelect>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            {errorMessage && (
                                <Form.Text className="text-danger">
                                    {errorMessage}
                                </Form.Text>
                            )}
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <FormButtons handleReset={handleReset} submitForm={submitForm} action={action} mandatoryFields={mandatoryFields}></FormButtons>
                </Modal.Footer>
            </Modal >
        </>
    );
}

export default FinanceForm;
